import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { NgxsModule } from '@ngxs/store';
import { SettingsEditState } from '@ops/services';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { OpsSubscriptionSettingsComponent } from './ops-subscription-settings.component';
import { OpsSubscriptionCardComponent } from '../ops-subscription-card/ops-subscription-card.component';
import { OpsSubscribedCardComponent } from '../ops-subscribed-card/ops-subscribed-card.component';
import { SpinnerComponent } from 'legacy/shared/components/src/lib/spinner/spinner.component';
import { OpsSubscriptionMessageModal } from '../ops-subscription-message-modal/ops-subscription-message-modal.component';
import { OpsCreateCompany } from '../ops-create-company/ops-create-company.component';
import { OpsAnnualMonthlySwitchComponent } from '../ops-annual-monthly-switch/ops-annual-monthly-switch.component';
import { OpsCurrencySwitchComponent } from '../ops-currency-switch/ops-currency-switch.component';
import { OpsInfoTooltipComponent } from '../ops-info-tooltip/ops-info-tooltip.component';
import { OpsPaymentMethodsSettingsModalComponent } from '../ops-payment-methods-settings/ops-payment-methods-settings-modal.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    OpsInputComponent,
    OpsSubscriptionCardComponent,
    OpsSubscribedCardComponent,
    OpsSubscriptionMessageModal,
    OpsAnnualMonthlySwitchComponent,
    OpsCurrencySwitchComponent,
    OpsCreateCompany,
    SpinnerComponent,
    OpsInfoTooltipComponent,
    OpsPaymentMethodsSettingsModalComponent,
    NgxsModule.forRoot([SettingsEditState]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
  ],
  declarations: [OpsSubscriptionSettingsComponent],
  exports: [OpsSubscriptionSettingsComponent],
})
export class OpsSubscriptionSettingsModule {}
